import { SpotIcon, StyledCard, TotalPatient } from "@components";
import { range_filter } from "@configs";
import { IClientInfo, ICouponVisualData } from "@interfaces";
import { theme } from "@utils";
import { Card, Divider, Progress, Select, Tag } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
interface IProps {
  patientFilter?: string;
  handleFilter?: (value: string) => void;
  patient: {
    data: ICouponVisualData;
    loading: boolean;
  };
}
export const PatientCircleCount = ({ patient: { data, loading } }: IProps) => {
  const { t } = useTranslation();

  return (
    <StyledCard loading={loading}>
      <header>
        <div>
          <p>{t("page.patient")}</p>
          <h5>{t("page.today_coupon_redeem_user_count")}</h5>
        </div>
      </header>
      <Divider />
      <section className="content">
        <Progress
          type="circle"
          percent={parseFloat(data?.todayCouponInfo?.redemeedPercentage || "")}
          strokeColor={theme.colors.main}
          size={200}
          format={() => (
            <>
              {" "}
              <span className="progress-inner-text">Total Redeem</span>
              <br />
              <span className="number">{data?.todayCouponInfo?.redemeedCount}</span>
            </>
          )}
        />
      </section>
      <Divider />
      <footer>
        <div>
          <SpotIcon color={theme.colors.orange} />
          <p>{t("page.generate")}</p>
          <p>{data?.todayCouponInfo?.totalCount}</p>
        </div>
        <div>
          <SpotIcon color={theme.colors.white} />
          <p>{t("page.pending")}</p>
          <p>{data?.todayCouponInfo?.pendingCount}</p>
        </div>
      </footer>
    </StyledCard>
  );
};

export const PatientNew = ({ patient: { data, loading }, patientFilter, handleFilter }: IProps) => {
  const { t } = useTranslation();

  return (
    <StyledCard loading={loading}>
      <header>
        <div>
          <p>{t("page.patient")}</p>
          <h5>{t("page.new_patient_counts")}</h5>
        </div>
        <div>
          <Select onChange={handleFilter} style={{ width: 100 }} defaultValue={patientFilter}>
            {range_filter.map((item) => (
              <Select.Option value={item} key={item}>
                {item}
              </Select.Option>
            ))}
          </Select>
        </div>
      </header>
      <Divider />
      <p className="patient-new">{data?.patientCount?.newCount}</p>
    </StyledCard>
  );
};

export const PatientTotal = ({ patient: { data, loading } }: IProps) => {
  const { t } = useTranslation();
  return (
    <StyledCard loading={loading}>
      <div className="flex">
        <TotalPatient />
        <div className="content">
          <p>{t("page.total_patients")}</p>
          <p className="total-count">{data?.patientCount?.totalCount}</p>
        </div>
      </div>
    </StyledCard>
  );
};

export const PatientRecord = ({ patient: { data, loading } }: IProps) => {
  const { t } = useTranslation();

  return (
    <StyledCard loading={loading}>
      <header>
        <p>{t("page.patient")}</p>
      </header>
      <div className="item flex">
        <p>{t("page.continue_the_treatment")}</p>
        <Tag color={theme.colors.green}>{data?.patientCount?.treatCount}</Tag>
      </div>
      <div className="item flex">
        <p>{t("page.never_redeemed")}</p>
        <Tag color={theme.colors.expired}>{data?.patientCount?.neverRedmeed}</Tag>
      </div>
    </StyledCard>
  );
};
